import {
  ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_CHECK,
  PROCESS_CODE_CHECK
} from '../../config/settings/regexes'

/**
 * Checks if the given value is a valid process code
 * (1 to 3 alphanumeric groups separated by hyphens, e.g. "5148-1-LE25", "48000").
 */
export const checkInputErrorProcessCode = () => value => {
  if (value && !PROCESS_CODE_CHECK.test(value)) {
    return 'El ID debe tener el formato X-X-X (grupos alfanuméricos separados por guiones)'
  }

  return ''
}

/**
 * To check if the given value contains only letters, numbers, and some symbols (._-,).
 */
export const checkOnlyLettersNumbersAndSomeSymbols = value =>
  ONLY_LETTERS_NUMBERS_AND_SOME_SYMBOLS_CHECK.test(value)
